import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LoginModule } from './login/login.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { NavigationComponent } from "./navigation/navigation.component";
import { AuthInterceptor } from "../common/interceptors/auth.interceptor";
import { AuthGuard } from "../common/guards/auth.guard";
import { ErrorResponseHandlerInterceptor } from "../common/interceptors/error-response-handler.interceptor";
import { GoogleMapsModule } from "@angular/google-maps";
import { SharedModule } from '../common/shared.module';
import { CommonDialogsComponent } from './common-dialogs/common-dialogs.component';
import {
  SolarCalculatorResultModule,
} from '../common/components/solar-calculation-result/solar-calculator-result.module';
import { ContactUsComponent } from './home-pages/contact-us/contact-us.component';
import { UserCheckStartupService } from '../common/initializers/user-check-startup.service';
import { Observable } from 'rxjs';
import { BasicUserData } from '../common/models/user/basic-user-data';
import { NgOptimizedImage } from '@angular/common';
import { WarningDialogComponent } from '../common/components/common-dialogs/warning-dialog/warning-dialog.component';
import {
  ResultTitleComponent,
} from '../common/components/solar-calculation-result/result-title/result-title.component';
import { CalculatorModule } from '../common/components/calculator/calculator.module';
import { WarningBarComponent } from '../common/components/warning-bar/warning-bar.component';
import { CustomerModule } from "./customer/customer.module";
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { CalculatorFrameModule } from './calculator-frame/calculator-frame.module';
import { HomeCalculatorComponent } from './home-pages/home-calculator/home-calculator.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PageNotFoundComponent,
    NavigationComponent,
    CommonDialogsComponent,
    ContactUsComponent,
    HomeCalculatorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoginModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    TranslocoRootModule,
    GoogleMapsModule,
    SolarCalculatorResultModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    WarningDialogComponent,
    ResultTitleComponent,
    CalculatorModule,
    WarningBarComponent,
    CalculatorFrameModule,
    CustomerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorResponseHandlerInterceptor,
      multi: true,
    },
    UserCheckStartupService,
    {
      // Provider for APP_INITIALIZER
      provide: APP_INITIALIZER,
      useFactory: userCheckStartupServiceFactory,
      deps: [UserCheckStartupService],
      multi: true,
    },
    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'calculator_result', alias: 'calculator_result' } },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

export function userCheckStartupServiceFactory(startupService: UserCheckStartupService): () => false | Observable<BasicUserData> {
  return () => startupService.load();
}
